import Cell from "./cell";
import template from "./cell.template";
import { views } from "../../../../core/components/table/body/row";
import { componentClasses } from "../../../../core/components/table/body/cell";
import { renderState } from "../../../../core/js/state-machine";

/**
 * Creates new row
 * @param {Object} config
 * @param {Number} config.id information about row id
 * @param {Array.<Object>} config.data data cell list
 * @param {Array.<Object>} config.columns list with column config for each data cell
 * @return {{
 *   element:HTMLElement,
 *   update:Function,
 *   cells:Array,
 * }}
 */
const Row = (config) => {
    /**
     * Helper function to creat an object with given row and col elements
     * @param {Number} row
     * @param {Number} col
     * @returns
     */
    const getCellProps = (row, col) => {
        return { row, col };
    };

    /**
     * Creates columns inside existent rows
     * @param {Array} data
     * @param {Object} columns
     * @param {Number} offset the offset you can add to the new rows.
     */
    const createColumns = (data, columns, offset = 0) => {
        let index = -1;
        const frag = document.createDocumentFragment();
        while (++index < columns.length) {
            const cellProps = getCellProps(id, index + offset);
            const columnProps = columns[index];
            const cellData = data[index];
            const config = { data: cellData, cellProps, columnProps };

            const templateConfig = { ...columnProps, value: cellData.value };
            const cellWrapper = new DOMParser().parseFromString(
                template(templateConfig),
                "text/html"
            ).body.firstElementChild;

            const cellContent = cellWrapper.querySelector(`.${componentClasses.cell}`);
            const cell = Cell(cellContent, config);
            frag.appendChild(cellWrapper);
            cells.push(cell);
        }
        element.appendChild(frag);
    };

    /**
     * Creates/removes columns from existent rows whenever data changes
     * @param {Object} newConfig
     */
    const update = (newConfig) => {
        id = newConfig.id;

        const colsOffset = newConfig.columns.length - cells.length;
        // Update existent
        cells.forEach((cell, index) => {
            const cellProps = getCellProps(id, index);
            cell.update(newConfig.data[index], cellProps);
        });

        //Cells to remove
        if (colsOffset < 0) {
            let removeCounter = Math.abs(colsOffset);
            while ((removeCounter < 0, removeCounter--)) {
                // Get the last item and remove
                const cell = cells.pop();
                cell.element.parentNode.removeChild(cell.element);
            }
        }
        //New cells to add
        else if (colsOffset > 0) {
            const lastIndex = cells.length;
            const dataSlice = newConfig.data.slice(lastIndex);
            const columnSlice = newConfig.columns.slice(lastIndex);
            createColumns(dataSlice, columnSlice, lastIndex);
        }
    };

    let id = config.id || -1;
    const cells = [];
    const element = renderState(views.rest, document.createElement("div"));

    createColumns(config.data, config.columns);

    const api = {
        element,
        update,
        cells,
    };

    return api;
};
export default Row;
